import { Component, input } from '@angular/core';

export type ButtonKind = 'primary' | 'secondary' | 'outline' | 'transparent';
export type ButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'button[tvdButton]',
  host: {
    // A bare <button> defaults to type="submit"; default to "button" so it never
    // submits a surrounding form by accident. An explicit type="submit" in the
    // template binds straight to the `type` input and overrides this.
    '[attr.type]': 'type()',
    '[attr.kind]': 'kind()',
    '[attr.disabled]': 'disabled() ? true : null',
    '[class.tvd-gradient-primary]': 'kind() === "primary"',
    '[class.tvd-gradient-secondary]': 'kind() === "secondary"',
    '[class.tvd-gradient-outline-primary]': 'kind() === "outline"',
    '[class.tvd-gradient-transparent-primary]': 'kind() === "transparent"',
  },
  template: '<ng-content/>',
  styleUrls: ['./button.scss'],
})
export class Button {
  readonly kind = input<ButtonKind>('primary');
  readonly type = input<ButtonType>('button');
  readonly disabled = input(false);
}
